import { Link, useLocation, useNavigate } from "react-router-dom";
import './Footer.css';
import { Image } from "@mantine/core";

const Footer = () => {

  const navigate = useNavigate();
  
  const location = useLocation();
  // Check if the current path is the homepage or trainingsplan page
  const showNavigation = location.pathname === '/' || 
    location.pathname === '/trainingsplan' || 
    location.pathname === '/voedingsplan' || 
    location.pathname === '/massa-bouwen' || 
    location.pathname === '/vet-verliezen';

  return (
    <div className="footer">
      <div className="container">

        {/* {showNavigation && (
        <div className="row align-items-center justify-space-center text-center copyright-footer">
          <span style={{ width: '100%' }}>© Healthy Living Project. Alle rechten voorbehouden 2024. </span>
        </div>
        )} */}
        
        <div className="row">
          <div className="col-md-4 mt-3">
            <a href="#reviews">
              <div className="stars-rating">
                <img style={{ maxWidth: '130px', marginRight: '12px', marginTop: '6px' }} src="https://cdn.shopify.com/s/files/1/0645/5541/7768/files/stars-46.png?v=1707467859" alt=""/>
                <span>
                  36+ reviews 
                </span> 
              </div>
            </a>
          </div>
          <div className="col-md-4">
            <div className="footer-logo">
              <a href="/">
                <Image mb="xl" src="/img/strongr-by-stef-logo-transparent.svg" height={95} width={208} alt="STRONGR by Stef" />
              </a>
            </div>
          </div>
          <div className="col-md-4 mt-3">
            <div className="socials-insta">
              <Link target="_blank" to="https://www.instagram.com/stefridder.coaching/">
                <h5 style={{ color: "#eee" }}>Volg mij op Instagram</h5>
              </Link>
              <Link target="_blank" to="https://www.instagram.com/stefridder.coaching/">
                <svg className="mt-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fff" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </Link>
            </div>
            <div className="socials-insta">
              <Link target="_blank" to="mailto:info@healthyliving-project.com">
                <h5 style={{ color: "#eee" }}>Vragen? Stuur mij een mail</h5>
              </Link>
              <Link target="_blank" to="mailto:info@healthyliving-project.com">
              <svg width="668" height="534" viewBox="0 0 668 534" fill="none" xmlns="http://www.w3.org/2000/svg" className="email-icon">
                <path d="M67.333 100.335L274 255.333C309.556 282 358.443 282 394 255.333L600.666 100.333" stroke="#fff" stroke-width="66.6667" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M567.333 33.667H100.667C63.8477 33.667 34 63.5147 34 100.334V433.667C34 470.486 63.8477 500.334 100.667 500.334H567.333C604.152 500.334 634 470.486 634 433.667V100.334C634 63.5147 604.152 33.667 567.333 33.667Z" stroke="#fff" stroke-width="66.6667" stroke-linecap="round"/>
              </svg>
              </Link>
            </div>
          </div>
        </div>
        <div className="row align-items-center justify-space-center text-center copyright-footer">
          <span style={{ width: '100%' }}>© Healthy Living Project. Alle rechten voorbehouden 2025. </span>
        </div>
      </div>
    </div>
  );
}
 
export default Footer;